module.exports = __webpack_public_path__ + "static/media/08_CALCINHA_ASA_DELTA_ESTAMPADA_04.708e793b.jpg";